<div class="page-container">
  <section class="shop-section">
    <div class="welcome-section">
      <div class="welcome-text">
        <h2>Willkommen in unserem exklusiven Shop</h2>
        <p>Entdecken Sie unsere sorgfältig ausgewählten Produkte, die Ihnen den Weg zum finanziellen Erfolg ebnen. 
           Mit unseren bewährten Strategien und Tools haben bereits zahlreiche Menschen ihre finanziellen Ziele erreicht. 
           Werden auch Sie Teil unserer Erfolgsgeschichte!</p>
      </div>
    </div>
    <div class="products-grid">
      <div class="product-card" *ngFor="let product of products$ | async">
        <div class="product-image">
          <img [src]="product.image" [alt]="product.name">
          <span class="product-tag" *ngIf="product.tag">{{ product.tag }}</span>
          <div *ngIf="isHorizonCryptoProduct(product)" class="guarantee-seal">
            <img src="assets/images/money-back.png" alt="100% Geld-zurück-Garantie" (click)="openVideo($event)">
          </div>
          <div *ngIf="isAcademyProduct(product)" class="guarantee-seal">
            <img src="assets/images/money-back.png" alt="100% Geld-zurück-Garantie" (click)="openAcademyPdf($event)">
          </div>
        </div>
        <div class="product-info">
          <h3>{{ product.name }}</h3>
          <div class="product-description" [class.expanded]="isDescriptionExpanded(product.id)">
            <p #descriptionText [attr.data-product-id]="product.id" [innerHtml]="formatDescription(product.description)"></p>
            <div class="description-buttons">
              <button *ngIf="shouldShowButton(product.id)" class="read-more-btn" (click)="toggleDescription(product.id, $event)">
                {{ isDescriptionExpanded(product.id) ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
              </button>
              <button *ngIf="!shouldShowButton(product.id) || isDescriptionExpanded(product.id)" class="read-more-btn" [routerLink]="['/produkte', product.productSlug]">
                Noch mehr erfahren
              </button>
            </div>
          </div>
          <div class="price-container">
            <div class="monthly-price">
              <span class="price-label">ab</span>
              <span class="current-price">€ {{ calculateMonthlyPrice(product.price) | number:'1.2-2' }}</span>
              <span class="price-label">mtl.</span>
            </div>
            <div class="tax-info">
              <span>(exkl. MwSt.)</span>
            </div>
          </div>
          <button class="cta-button" 
                  (click)="addToCart(product.id)"
                  [disabled]="isInCart(product.id)"
                  [class.in-cart]="isInCart(product.id)">
            <span *ngIf="!isInCart(product.id)">In den Warenkorb</span>
            <span *ngIf="isInCart(product.id)">Im Warenkorb</span>
          </button>
        </div>
      </div>
    </div>
  </section>
  <app-cart-sidebar></app-cart-sidebar>
</div>
